export default __webpack_public_path__ + "static/1420-7103aba04abe1710b02cd1669cf8d2c6.gif";